/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Plan_UnavailableInputs */



/**
* | output |
* | --- |
* | "No floor plan available" |
*
* @param {Module_Add_Plan_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_plan_unavailable = /** @type {((inputs?: Module_Add_Plan_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Plan_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No floor plan available")
	return /** @type {LocalizedString} */ ("Aucun plan disponible")
});